<template>
  <div class="progress">
      <div class="scale-progress">
        <div class="light" :style="{'width':light}"></div>
        <div class="green" :style="{'width':green}"></div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  inject: { disableProgressBarText: { default: false } },
  props: {
    steps: Number,
    step: Number,
    fromStep: Number
  },
  data () {
    return {
      green: null,
      light: null,
      widthStep: 100 / this.steps
    }
  },
  computed: {
    stepsLeftString () {
      const preMarker = this.$i18n.locale === 'ar' ? '\u200f' : ''
      return `${preMarker}${this.stepsLeft}`
    },
    stepsLeft () {
      return this.steps - this.step + 1
    }
  },
  methods: {
    updateProgressBar () {
      this.green = Math.trunc(this.widthStep * this.fromStep) + '%'
      this.light = Math.trunc(this.widthStep * (this.fromStep + 1)) + '%'
      setTimeout(() => {
        this.light = Math.trunc(this.widthStep * (this.step + 1)) + '%'
        this.green = Math.trunc(this.widthStep * this.step) + '%'
      }, 10)
    }
  },
  watch: {
    step () {
      this.updateProgressBar()
    }
  },
  mounted () {
    this.updateProgressBar()
  }
}
</script>
